import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import Nouserimage from "../../../assets/images/users/no_image.png";

// users
import user1 from "../../../assets/images/users/avatar-1.jpg";
import UserService from "Api/Services/UserService";

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [username, setusername] = useState("Admin");
  const [profileImage, setProfileImage] = useState();
  const handleLogout = async (e) => {
    localStorage.removeItem("InfuseoneUserToken");
    localStorage.removeItem("Infuseonerolename");
    localStorage.removeItem("Infuseoneuserinfo");
    navigate("/");
  }

  const getUser = async () => {
    try {
      let response = await UserService.GetUser().json();
      setusername(response.data.username)
      const imageUrl = response.data.profile_image
        ? `${process.env.REACT_APP_PROFILE_IMAGE_API_URL}/${response.data.profile_image}`
        : null;
      setProfileImage(imageUrl)
      if (response.status == false) {
        setError(response.message);
        return;
      }
    } catch (error) {
      setError('something went wrong');
      return;
    }
  };

  useEffect(() => {
    getUser();
  }, [props.success]);

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={profileImage ? profileImage : Nouserimage}
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ms-2 me-1">{username ? username : 'User'}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          {/* <DropdownItem tag="a" href="">
            {" "}
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {props.t("Profile")}{" "}
          </DropdownItem>  */}
            {/* <Link to="/user-profile" className="dropdown-item">
              <i className="bx bx-user font-size-16 align-middle me-1 text-danger" />
              <span>{props.t("Profile")}</span>
            </Link>

            <Link to="/change-password" className="dropdown-item">
              <i className="bx bx-key font-size-16 align-middle me-1 text-danger" />
              <span>{props.t("Change Password")}</span>
            </Link> */}
          {/* <div className="dropdown-divider" /> */}
          <Link to="#" className="dropdown-item" onClick={handleLogout}>
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
